import { render, staticRenderFns } from "./CustomerAccessSetup.html?vue&type=template&id=3288e75d&scoped=true&external"
import script from "./CustomerAccessSetup.js?vue&type=script&lang=js&external"
export * from "./CustomerAccessSetup.js?vue&type=script&lang=js&external"
import style0 from "./CustomerAccessSetup.scss?vue&type=style&index=0&id=3288e75d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288e75d",
  null
  
)

export default component.exports